import { render, staticRenderFns } from "./ClassicInfinityDimensionRow.vue?vue&type=template&id=239f89fe&scoped=true&"
import script from "./ClassicInfinityDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ClassicInfinityDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./ClassicInfinityDimensionRow.vue?vue&type=style&index=0&id=239f89fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239f89fe",
  null
  
)

export default component.exports